function cleanPathname(pathname: string): string {
  return pathname.endsWith('/')
    ? pathname.substring(0, pathname.length - 1)
    : pathname;
}

export default cleanPathname;
